import { render, staticRenderFns } from "./prospects.vue?vue&type=template&id=3560f674&"
import script from "./prospects.vue?vue&type=script&lang=js&"
export * from "./prospects.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports